import { c as _c } from "react/compiler-runtime";
import PaymentInput from './inputs/PaymentInput';
const PaymentField = props => {
    const $ = _c(2);
    let t0;
    if ($[0] !== props) {
        t0 = <PaymentInput id="payment-field" {...props}/>;
        $[0] = props;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    return t0;
};
export default PaymentField;
